import { cn } from '@lair-finance/util'
import { MenuLink } from '@/domains/header/ui/MenuList/MenuLink.tsx'
import { DESKTOP_MENU_LIST } from '@/domains/header/config'
import { useLocation } from 'react-router-dom'

export function MenuList({ className }: { className?: string }) {
  const location = useLocation()

  return (
    <div className={cn('inline-flex-center gap-x-2', className)}>
      {DESKTOP_MENU_LIST.map(item => (
        <MenuLink key={item.name} to={item.path} active={item.isActive(location.pathname)}>
          {item.name}
        </MenuLink>
      ))}
    </div>
  )
}
